import Welcome from "./components/Welcome";
import {
  DashboardOutlined,
  HistoryOutlined,
  DeleteOutlined,
  TeamOutlined,
  DownloadOutlined,
  MessageOutlined
} from "@ant-design/icons";

// Icon wrapper component for consistent styling
const StepIcon = ({ icon: Icon, color = "#0010f7" }) => (
  <div style={{
    width: 44,
    height: 44,
    borderRadius: 12,
    background: `linear-gradient(135deg, ${color}20 0%, ${color}10 100%)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 12
  }}>
    <Icon style={{ fontSize: 22, color }} />
  </div>
);

export const adminSidebarSteps = [
  // Intro
  {
    attachTo: { on: "center" },
    text: (
      <div>
        <Welcome />
      </div>
    ),
    disableBeacon: true,
    placement: "center",
    styles: {
      options: {
        width: 1200,
        zIndex: 1000,
      },
    },
    showProgress: false,
  },
  // Dashboard
  {
    attachTo: { element: ".joy-dash-admin", on: "right" },
    text: (
      <div>
        <StepIcon icon={DashboardOutlined} color="#4f46e5" />
        <h3 style={{ margin: "0 0 8px 0", fontSize: 18 }}>Your Command Center</h3>
        <p style={{ color: "#64748b", margin: "0 0 12px 0", lineHeight: 1.5 }}>
          See everything at a glance! Track how your team uses AI, monitor credits,
          and spot trends to make smarter decisions.
        </p>
        <div style={{
          background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
          padding: 12,
          borderRadius: 8,
          fontSize: 13,
          color: "#0369a1"
        }}>
          ✨ Check in daily to stay on top of your team's productivity
        </div>
      </div>
    ),
    placement: "right",
    styles: {
      options: {
        width: 360,
        zIndex: 1000,
      },
    },
    showProgress: true,
  },
  // History
  {
    attachTo: { element: ".joy-history-admin", on: "right" },
    text: (
      <div>
        <StepIcon icon={HistoryOutlined} color="#8b5cf6" />
        <h3 style={{ margin: "0 0 8px 0", fontSize: 18 }}>Never Lose Great Ideas</h3>
        <p style={{ color: "#64748b", margin: "0 0 12px 0", lineHeight: 1.5 }}>
          Every brilliant AI generation is saved here. Search, filter, and revisit
          your team's work anytime. Perfect for reusing great content!
        </p>
        <div style={{
          background: "linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%)",
          padding: 12,
          borderRadius: 8,
          fontSize: 13,
          color: "#7c3aed"
        }}>
          🔍 Use search to quickly find that perfect response from last week
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "right",
    styles: {
      options: {
        width: 360,
        zIndex: 1000,
      },
    },
    showProgress: true,
  },
  // Trash
  {
    attachTo: { element: ".joy-trash-admin", on: "right" },
    text: (
      <div>
        <StepIcon icon={DeleteOutlined} color="#ef4444" />
        <h3 style={{ margin: "0 0 8px 0", fontSize: 18 }}>Oops-Proof Recovery</h3>
        <p style={{ color: "#64748b", margin: "0 0 12px 0", lineHeight: 1.5 }}>
          Deleted something by mistake? No worries! Everything lands here first,
          giving you 30 days to change your mind.
        </p>
        <div style={{
          background: "linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)",
          padding: 12,
          borderRadius: 8,
          fontSize: 13,
          color: "#dc2626"
        }}>
          ⏰ Items auto-delete after 30 days, so restore what you need soon!
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "right",
    styles: {
      options: {
        width: 360,
        zIndex: 1000,
      },
    },
    showProgress: true,
  },
  // Team
  {
    attachTo: { element: ".joy-team-admin", on: "right" },
    text: (
      <div>
        <StepIcon icon={TeamOutlined} color="#10b981" />
        <h3 style={{ margin: "0 0 8px 0", fontSize: 18 }}>Grow Your AI Team</h3>
        <p style={{ color: "#64748b", margin: "0 0 12px 0", lineHeight: 1.5 }}>
          Add teammates with a simple email invite. Everyone gets access to your
          shared AI copilots and can start being productive right away!
        </p>
        <div style={{
          background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
          padding: 12,
          borderRadius: 8,
          fontSize: 13,
          color: "#15803d"
        }}>
          🎯 Invite your first teammate to double your AI power
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "right",
    styles: {
      options: {
        width: 360,
        zIndex: 1000,
      },
    },
    showProgress: true,
  },

  // Download
  {
    attachTo: { element: ".joy-download-extension", on: "bottom" },
    text: (
      <div style={{ textAlign: "center" }}>
        <StepIcon icon={DownloadOutlined} color="#f59e0b" />
        <h3 style={{ margin: "0 0 8px 0", fontSize: 18 }}>AI Everywhere You Work</h3>
        <p style={{ color: "#64748b", margin: "0 0 16px 0", lineHeight: 1.5 }}>
          Get our browser extension and use AI on any website. Select text,
          click, and let AI help – it's that easy!
        </p>
        <div style={{ textAlign: "left", maxWidth: 280, margin: "0 auto 16px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, color: "#374151" }}>
            <span style={{ color: "#10b981" }}>✓</span> Works on Gmail, Docs, LinkedIn, anywhere
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, color: "#374151" }}>
            <span style={{ color: "#10b981" }}>✓</span> Highlight text → Get AI help instantly
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#374151" }}>
            <span style={{ color: "#10b981" }}>✓</span> All your copilots, one click away
          </div>
        </div>
        <div style={{
          background: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
          color: "white",
          padding: 14,
          borderRadius: 10,
          fontSize: 14,
          fontWeight: 500
        }}>
          Ready to 10x your productivity? Let's go! 🚀
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "bottom",
    styles: {
      options: {
        width: 380,
        zIndex: 1000,
      },
    },
    locale: {
      last: "Let's go! 🎉",
    },
    showProgress: true,
  },
];

export const memberSidebarSteps = [
  // Intro
  {
    attachTo: { on: "center" },
    text: (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Welcome />
      </div>
    ),
    disableBeacon: true,
    placement: "center",
    styles: {
      options: {
        width: 1200,
        zIndex: 1000,
      },
    },
    showProgress: false,
  },
  // Dashboard
  {
    attachTo: { element: ".joy-dash-member", on: "right" },
    text: (
      <div>
        <StepIcon icon={DashboardOutlined} color="#4f46e5" />
        <h3 style={{ margin: "0 0 8px 0", fontSize: 18 }}>Your Personal Hub</h3>
        <p style={{ color: "#64748b", margin: "0 0 12px 0", lineHeight: 1.5 }}>
          See your AI usage at a glance! Track your credits, view your stats,
          and watch your productivity grow day by day.
        </p>
        <div style={{
          background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
          padding: 12,
          borderRadius: 8,
          fontSize: 13,
          color: "#0369a1"
        }}>
          ✨ Start your day here to see what you've accomplished
        </div>
      </div>
    ),
    placement: "right",
    styles: {
      options: {
        width: 360,
        zIndex: 1000,
      },
    },
    showProgress: true,
  },
  // Chats
  {
    attachTo: { element: ".joy-chats-member", on: "right" },
    text: (
      <div>
        <StepIcon icon={MessageOutlined} color="#8b5cf6" />
        <h3 style={{ margin: "0 0 8px 0", fontSize: 18 }}>Pick Up Where You Left Off</h3>
        <p style={{ color: "#64748b", margin: "0 0 12px 0", lineHeight: 1.5 }}>
          All your AI conversations live here. Continue a chat from yesterday,
          or revisit a great idea from last month. Nothing gets lost!
        </p>
        <div style={{
          background: "linear-gradient(135deg, #faf5ff 0%, #f3e8ff 100%)",
          padding: 12,
          borderRadius: 8,
          fontSize: 13,
          color: "#7c3aed"
        }}>
          💬 Your chats are auto-saved, so you'll never lose great conversations
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "right",
    styles: {
      options: {
        width: 360,
        zIndex: 1000,
      },
    },
    showProgress: true,
  },
  // Team
  {
    attachTo: { element: ".joy-team-member", on: "right" },
    text: (
      <div>
        <StepIcon icon={TeamOutlined} color="#10b981" />
        <h3 style={{ margin: "0 0 8px 0", fontSize: 18 }}>Meet Your Squad</h3>
        <p style={{ color: "#64748b", margin: "0 0 12px 0", lineHeight: 1.5 }}>
          See who else is on your team and what everyone's working on.
          Collaboration is better when you know who's who!
        </p>
        <div style={{
          background: "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)",
          padding: 12,
          borderRadius: 8,
          fontSize: 13,
          color: "#15803d"
        }}>
          👋 Need help? Your admin is just a message away
        </div>
      </div>
    ),
    disableBeacon: true,
    placement: "right",
    styles: {
      options: {
        width: 360,
        zIndex: 1000,
      },
    },
    showProgress: true,
  },
  // Final step
  {
    attachTo: { element: ".joy-chats-member", on: "right" },
    text: (
      <div style={{ textAlign: "center" }}>
        <div style={{
          fontSize: 48,
          marginBottom: 12
        }}>
          🎉
        </div>
        <h3 style={{ margin: "0 0 8px 0", fontSize: 20 }}>You're Ready to Roll!</h3>
        <p style={{ color: "#64748b", margin: "0 0 16px 0", lineHeight: 1.5 }}>
          That's all you need to know. Now go create something amazing with AI!
        </p>
        <div style={{
          background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
          padding: 14,
          borderRadius: 10,
          fontSize: 14,
          color: "#0369a1"
        }}>
          <strong>Quick shortcut:</strong> Press <kbd style={{
            background: "#e2e8f0",
            padding: "2px 6px",
            borderRadius: 4,
            fontFamily: "monospace",
            fontSize: 12
          }}>Cmd/Ctrl + Shift + K</kbd> to open Copilotly anywhere!
        </div>
      </div>
    ),
    disableBeacon: true,
    disableOverlayClose: true,
    hideCloseButton: true,
    spotlightClicks: true,
    placement: "right",
    styles: {
      options: {
        width: 360,
        zIndex: 1000,
      },
    },
    locale: {
      last: "Start exploring! 🚀",
    },
    showProgress: true,
  },
];
